import { AllocationWarningConfig, Identifiable, Planzone } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function updateAllocationWarningConfig(httpClient: HttpClient) {
  return (
    planzone: Identifiable<Planzone>,
    allocationWarningConfig: AllocationWarningConfig,
  ) =>
    new Promise<Identifiable<Planzone>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<Planzone>>({
          endpoint: `/planzones/${planzone.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            criticalDailyAmplitudeHours:
              allocationWarningConfig.criticalDailyAmplitudeHours,
            criticalDailyVolumeHours:
              allocationWarningConfig.criticalDailyVolumeHours,
            criticalRestPeriodHours:
              allocationWarningConfig.criticalRestPeriodHours,
          },
        })
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { updateAllocationWarningConfig };
